var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 472,
    viewBox: "0 0 228 472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 3.71906,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 199.237,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 101.479,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 296.994,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 468.071,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 52.598,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 248.116,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 419.192,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 150.358,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 345.871,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 28.1566,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 223.674,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 394.752,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 125.916,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 321.434,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 77.0355,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 272.555,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 443.631,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 174.795,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.916,
    cy: 370.311,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 3.71906,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 199.237,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 101.479,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 296.994,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 468.071,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 52.598,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 248.116,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 419.192,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 150.358,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 345.871,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 28.1566,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 223.674,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 394.752,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 125.916,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 321.434,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 77.0355,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 272.555,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 443.631,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 174.795,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1585,
    cy: 370.311,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 3.71906,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 199.237,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 101.479,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 296.994,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 468.071,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 52.598,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 248.116,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 419.192,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 150.358,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 345.871,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 28.1566,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 223.674,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 394.752,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 125.916,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 321.434,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 77.0355,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 272.555,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 443.631,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 174.795,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.674,
    cy: 370.311,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 3.71906,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 199.237,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 101.479,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 296.994,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 468.071,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 52.598,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 248.116,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 419.192,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 150.358,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 345.871,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 28.1566,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 223.674,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 394.752,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 125.916,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 321.434,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 77.0355,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 272.555,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 443.631,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 174.795,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.795,
    cy: 370.311,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 3.71906,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 199.237,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 101.479,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 296.994,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 468.071,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 52.598,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 248.116,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 419.192,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 150.358,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 345.871,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 28.1566,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 223.674,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 394.752,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 125.916,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 321.434,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 77.0355,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 272.555,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 443.631,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 174.795,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0374,
    cy: 370.311,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 3.71906,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 199.237,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 101.479,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 296.994,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 468.071,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 52.598,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 248.116,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 419.192,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 150.358,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 345.871,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 28.1566,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 223.674,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 394.752,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 125.916,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 321.434,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 77.0355,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 272.555,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 443.631,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 174.795,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.356,
    cy: 370.311,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 3.71906,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 199.237,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 101.479,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 296.994,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 468.071,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 52.598,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 248.116,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 419.192,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 150.358,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 345.871,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 28.1566,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 223.674,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 394.752,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 125.916,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 321.434,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 77.0355,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 272.555,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 443.631,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 174.795,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.598,
    cy: 370.311,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 3.71906,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 199.237,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 101.479,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 296.994,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 468.071,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 52.598,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 248.116,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 419.192,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 150.358,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 345.871,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 28.1566,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 223.674,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 394.752,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 125.916,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 321.434,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 77.0355,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 272.555,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 443.631,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 174.795,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.71906,
    cy: 370.311,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 3.71906,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 199.237,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 101.479,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 296.994,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 468.071,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 52.598,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 248.116,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 419.192,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 150.358,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 345.871,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 28.1566,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 223.674,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 394.752,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 125.916,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 321.434,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 77.0355,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 272.555,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 443.631,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 174.795,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.235,
    cy: 370.311,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 3.71906,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 199.237,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 101.479,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 296.994,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 468.071,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 52.598,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 248.116,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 419.192,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 150.358,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 345.871,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 28.1566,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 223.674,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 394.752,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 125.916,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 321.434,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 77.0355,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 272.555,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 443.631,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 174.795,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.477,
    cy: 370.311,
    r: 3.71906,
    fill: "#C4C4C4",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.f51c2dfc1730daf88d8066fb532c19a9.svg";
export { ForwardRef as ReactComponent };